module.exports = __webpack_public_path__ + "static/media/chair-office.402a4417.svg";